<header
  style="
    background: url('images/bandeira-minas-gerais-header.png') no-repeat, linear-gradient(90deg, rgb(0, 0, 0) 0%, rgb(202, 202, 202, 0.4) 100%);
    background-size: cover;
    background-blend-mode: hue;
    background-position: 0% 80%;">
  <div class="links-breadcrump-header">
    @for (link of RouteStack;track $index){
    @if ($index === 0) {
    <span tabindex="0" class="route-clickable" (click)="navigateToRoute(link.route)"
      (keyup.enter)="navigateToRoute(link.route)">{{link.title}}</span>
    }
    @else {
    <span style="color: var(--tom-1-jornal);"> > </span>
    <span tabindex="0" class="route-clickable" (click)="navigateToRoute(link.route)"
      (keyup.enter)="navigateToRoute(link.route)">{{link.title}}</span>
    }
    }
  </div>
  
  @if(Title) {
  <div class="title-header">
    <h1 style="color: white">{{Title}}</h1>
  </div>
  <hr>
  }
</header>
